import { Box, FormControlLabel, Typography, Checkbox as MuiCheckbox } from '@mui/material'
import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { ICheckbox } from '../../Checkbox/types'
import DividerTAG from '../../DividerTAG'
import FormLayout from '../FormLayout'
import { ISelectOneForm } from './types'

const CheckboxCustom: React.FC<ICheckbox> = ({ label = '', control, fieldName, value, disabled=false }) => {
  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      {control && (
        <Controller
          render={({ field }) => (
            <FormControlLabel
              control={
                <MuiCheckbox
                  {...field}
                  value={value}
                  onChange={e => {
                    field.onChange(e.target.value)
                  }}
                  disabled={disabled}
                />
              }
              checked={field.value === value}
              label={<Typography variant='boldTextMedium'>{label}</Typography>}
            />
          )}
          name={fieldName}
          control={control}
          defaultValue={''}
        />
      )}
    </Box>
  )
}

const SelectOneForm: React.FC<ISelectOneForm> = ({
  selectOptions,
  updateNumberOfChanges,
  submitFunctions,
  testTest = '',
  defaultValues = { location: '' },
  fieldName = 'location',
  disabled = false,
}) => {
  const [changes, setChanges] = useState(0)
  const formMethods = useForm<any>({
    defaultValues,
    mode: 'onChange',
    shouldFocusError: false,
  })
  const { control, formState, getValues } = formMethods
  const { dirtyFields } = formState
  const changesNumber = Object.keys(dirtyFields).length

  const unmountLogic = () => {
    updateNumberOfChanges(-changes)
  }

  useEffect(() => {
    return () => {
      unmountLogic()
    }
  }, [changes])

  useEffect(() => {
    if (changesNumber == changes) return
    updateNumberOfChanges(changesNumber - changes)
    setChanges(changesNumber)
  }, [formState])

  const submitHandler = () => {
    const currentValues = getValues()
    return currentValues
  }
  submitFunctions[testTest] = submitHandler
  // console.log('disabled', disabled)
  const renderCheckboxes = (data: any) => {
    return Object.keys(data).map((key: string | number, index: any) => {
      return (
        <Box key={`${key}+${index}`}>
          <CheckboxCustom
            control={control}
            fieldName={fieldName}
            label={data[key].label}
            value={key}
            disabled={disabled}
          />
          <DividerTAG />
        </Box>
      )
    })
  }
  return (
    <FormLayout>
      <Typography variant='labelBold'>Select One</Typography>
      <DividerTAG />
      {renderCheckboxes(selectOptions)}
    </FormLayout>
  )
}

export default SelectOneForm
